import { render, staticRenderFns } from "./ServidoresOLT.vue?vue&type=template&id=6d1e1807&"
import script from "./ServidoresOLT.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports